import { Component, Output, EventEmitter, Input } from '@angular/core'

import { ThemeManagerService } from '../../services';
import { ITheme } from '../../models';


@Component({
	selector: 'theme-switcher',
	templateUrl: './theme-switcher.component.html',
	standalone: false
})
export class ThemeSwitcherComponent {
	@Input() itemClass = '';
	@Output() selectTheme: EventEmitter<ITheme> = new EventEmitter()

	get themes() {
		return this.themeService.themes
	}

	constructor(private themeService: ThemeManagerService) {}

	onSelect(value: ITheme) {
		this.themeService.useTheme(value.id)
		this.selectTheme.next(value)
	}
}
